<template>
    <facet-template
        :show-clear-link="isFiltered"
        :title="title"
        class="minmax-facet"
        @clear="clearSelected"
    >
      <span slot="facetLabel">
            {{ title }}
            <small class="font-italic font-weight-normal monthly-payment">
               {{minMaxLabel}}
            </small>
        </span>
        <div class="d-flex justify-content-between">
            <div class="left-select">
                <label for="min">
                    {{ minLabel }}
                </label>
                <select
                    id="min"
                    v-model="selectedMin"
                    class="form-control-sm custom-select w-100"
                    name="min"
                >
                    <option :value="null">Any</option>
                    <option
                        v-for="minOption in minOptions"
                        :key="minOption"
                        :value="minOption"
                    >
                        {{ minOption | numeral(format) }}{{ suffix }}
                    </option>
                </select>
            </div>

            <div class="right-select">
                <label for="max"> {{ maxLabel }} </label>
                <select
                    id="max"
                    v-model="selectedMax"
                    class="form-control-sm custom-select w-100"
                    name="max"
                >
                    <option :value="null">Any</option>
                    <option
                        v-for="maxOption in maxOptions"
                        :key="maxOption"
                        :value="maxOption"
                    >
                        {{ maxOption | numeral(format) }}{{ suffix }}
                    </option>
                </select>
            </div>
        </div>
    </facet-template>
</template>

<style lang="scss">
.minmax-facet {
    .left-select,
    .right-select {
        width: 48%;
    }

    label {
        font-weight: normal;
        font-size: 12px;
    }
}
</style>

<script>
import FacetTemplate from "./FacetTemplate";
import _ from "lodash";
import numeral from "numeral";

export default {
    components: {
        FacetTemplate,
    },
    filters: {
        numeral(val, format) {
            if (!_.isNumber(val)) {
                return val;
            }

            return numeral(val).format(format);
        },
    },
    props: {
        title: {
            type: String,
            required: true,
        },
        format: {
            type: String,
            default: "$0,0",
        },
        step: {
            type: Number,
            default: 1000,
        },
        max: {
            type: Number,
            default: 175000,
        },
        range: {
            type: Object,
            required: true,
        },
        inclusive: {
            type: Boolean,
            required: false,
            default: false,
        },
        suffix: {
            type: String,
            default: "",
        },
        value: {
            type: Object,
            required: true,
        },
        minLabel: {
            type: String,
            required: false,
            default: "starting at",
        },
        maxLabel: {
            type: String,
            required: false,
            default: "up to",
        },
    },

    data() {
        return {
            selectedMin: this.value.min,
            selectedMax: this.value.max,
        };
    },

    computed: {
        minOptions() {
            const start = _.get(this.range, "min", 0);
            let end = _.get(this.range, "max", this.max);

            end = end > this.max ? this.max : end;

            // a maximum price has been selected
            if (!_.isNil(this.selectedMax)) {
                end =
                    _.toInteger(this.selectedMax) -
                    (this.inclusive ? 0 : this.step);
            }

            return this.generateOptions(start, end);
        },
        maxOptions() {
            let start = _.get(this.range, "min", 0);
            let end = _.get(this.range, "max", this.max);

            end = end > this.max ? this.max : end;

            // a minimum price has been selected
            if (!_.isNil(this.selectedMin)) {
                start =
                    _.toInteger(this.selectedMin) +
                    (this.inclusive ? 0 : this.step);
            }

            return this.generateOptions(start, end);
        },
        isFiltered() {
            return !_.isNil(this.selectedMin) || !_.isNil(this.selectedMax);
        },

        minMaxLabel(){
            if(this.title == 'Year'){
               return this.getYearLable()
            }else{
               return this.getPriceLable()
            }
        },

        minMaxLabelClass(){
            if(this.title=='Monthly Payment'){
                return 'font-italic font-weight-normal monthly-payment'
            }else{
                return 'font-italic font-weight-normal'
            }
        }
    },
    watch: {
        value: function (val) {
            if (_.isEqual(val, { min: null, max: null })) {
                this.clearSelected();
            }
        },
        range: function (newRange) {
            if (!_.isNil(this.selectedMin) && newRange.min > this.selectedMin) {
                this.selectedMin = newRange.min;
            }

            if (!_.isNil(this.selectedMax) && newRange.max < this.selectedMax) {
                this.selectedMax = newRange.max;
            }
        },
        selectedMin() {
            this.$emit("input", {
                min: this.selectedMin,
                max: this.selectedMax,
            });
        },
        selectedMax() {
            this.$emit("input", {
                min: this.selectedMin,
                max: this.selectedMax,
            });
        },
    },
    methods: {
        clearSelected() {
            this.selectedMin = null;
            this.selectedMax = null;
        },
        generateOptions(start, end) {
            // 0 will be covered by "Any" option
            if (start === 0) {
                start = this.step;
            }

            const available =
                start !== end ? _.range(start, end, this.step) : [start];
            const maxAdded = _.max(available);
            if (maxAdded < end) {
                available.push(end);
            }
            return available;
        },

        getYearLable(){
            if(this.value.min && this.value.max){
                    return `(from ${this.value.min} - up to ${this.value.max})`
            }else if(this.value.min){
                     return `(from ${this.value.min})`
            }else if(this.value.max){
                 return `(up to ${this.value.max})`
            }else{
                return ''
            }
        },

        getPriceLable(){
            if(this.value.min && this.value.max){
                    return `(from $${this.value.min} - up to $${this.value.max})`
            }else if(this.value.min){
                     return `(from $${this.value.min})`
            }else if(this.value.max){
                 return `(up to $${this.value.max})`
            }else{
                return ''
            }
        },
    },
};
</script>
<style lang="scss">

.monthly-payment {
    font-size : 0.737rem
}

</style>
